import { useState } from "react";

import Dropdown from "../Dropdown/Dropdown";
import TitleSection from "../TitleSection/TitleSection";
import SubtitleSection from "../SubtitleSection/SubtitleSection";

import "./FaqSection.css";



const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      id: 1,
      title: "¿Son estos tests un reemplazo de la consulta con un oftalmólogo?",
      content:
        "No, en absoluto. Nuestros tests son herramientas de orientación y apoyo. Te dan una primera pista sobre tu visión, pero la única persona que puede realizar un diagnóstico oficial y darte una receta son un profesional cualificado (oftalmólogo u optometrista).",
    },
    {
      id: 2,
      title: "¿Cuánto tiempo me tomará hacer un test visual?",
      content:
        "¡Muy poco! La mayoría de nuestros tests están diseñados para completarse en menos de 5 minutos. Queremos que sea una revisión rápida y sin complicaciones para tu día a día.",
    },
    {
      id: 3,
      title: "¿Necesito algún equipo o aparato especial para realizar las pruebas?",
      content:
        "No. Solo necesitas tu teléfono, tablet o computadora y una conexión a internet estable. Algunos tests requerirán que te alejes una distancia específica o que te cubras un ojo, pero todas las instrucciones se dan de forma clara.",
    },
    {
      id: 4,
      title: "¿Tengo que pagar algo o registrarme para hacer los tests?",
      content:
        "Absolutamente no. Todos nuestros tests visuales son completamente gratuitos y puedes empezarlos ahora mismo sin necesidad de crear una cuenta o dejarnos tu email. Cuidar tu vista debe ser accesible para todos.",
    },
    {
      id: 5,
      title: "¿Qué debo hacer si el resultado de mi test me preocupa?",
      content:
        "Si un resultado te genera inquietud, el siguiente paso es programar una cita con uno de nuestros especialistas colaboradores. Ellos podrán realizar una evaluación completa y confirmar o descartar cualquier problema con un diagnóstico profesional.",
    },
    {
      id: 6,
      title: "¿Cómo sé qué test es el correcto para mí?",
      content:
        "Es fácil. Si no tienes un síntoma específico, te recomendamos empezar con el Test de Agudeza Visual a Distancia. Si notas algo en particular (como ver borroso de cerca o líneas torcidas), ve a la sección 'Tu Síntoma, Tu Prueba Rápida' y elige tu molestia.",
    },
  ];

  return (
    <section className="faq-section">
      <TitleSection titleSection={"FAQ"} />
      <SubtitleSection subtitleSection={"Preguntas Frecuentes"} />
      <div className="dropdowns-container">
        {faqs.map((faq, index) => (
          <Dropdown
            key={faq.id}
            title={faq.title}
            content={faq.content}
            isOpen={openIndex === index}
            onToggle={() => setOpenIndex(openIndex === index ? null : index)}
          />
        ))}
      </div>
    </section>
  );
};

export default FaqSection;
